// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PatientAccountGetPatientAccountDefaultResponse {
    static getAttributeTypeMap() {
        return PatientAccountGetPatientAccountDefaultResponse.attributeTypeMap;
    }
}
PatientAccountGetPatientAccountDefaultResponse.discriminator = undefined;
PatientAccountGetPatientAccountDefaultResponse.additionalProperties = false;
PatientAccountGetPatientAccountDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "GetPatientAccountResponseModel"
    },
];
//# sourceMappingURL=patientAccountGetPatientAccountDefaultResponse.js.map